module.exports = __webpack_public_path__ + "static/img/ki-readiness-check_logo.cc516ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing-icons/ki-readiness-check_logo.png
// module id = DipA
// module chunks = 1